import React from 'react';
import { IconButton } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const scrollToTop = () => {
  // Replace 'targetElement' with the actual DOM element you want to scroll to.
  const targetElement = document.getElementById('targetElementId');
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' });
  }
};

const LocationButton = () => {
  return (
    <IconButton sx={{float:"left"}} onClick={scrollToTop} color="primary" aria-label="Scroll to top">
      <LocationOnIcon sx={{float:"left", marginTop:"5px", marginRight:"0px", color:"#ffea00"}} />
    </IconButton>
  );
};
export default LocationButton;
